import { OrgbrainErrorCodes } from '@orgbrain/lib-data';

import { ShareholderRecord } from '../classes/shared';
import { ShareNumbers } from './sharenumber-classes';

export function checkAllNumbers({
  records,
  allowGaps,
}: {
  records: Array<ShareholderRecord>;
  allowGaps: boolean;
}): { [shareClass: string]: number } {
  const shareRecordsByClass: { [shareclassId: string]: ShareholderRecord[] } = {};
  const totalAmount = {};

  for (const record of records) {
    shareRecordsByClass[record.shareclassId] = shareRecordsByClass[record.shareclassId] || [];
    shareRecordsByClass[record.shareclassId].push(record);
  }

  for (const classId of Object.keys(shareRecordsByClass)) {
    const amount = checkNumbers({ records: shareRecordsByClass[classId], allowGaps });
    totalAmount[classId] = amount;
  }

  return totalAmount;
}

// TODO pass allowNoneSequential.
export function checkNumbers({
  records,
  allowGaps,
}: {
  records: Array<ShareholderRecord>;
  allowGaps: boolean;
}): number {
  const numbers: ShareNumbers[] = [];
  // console.log(records);
  let i = 1;
  for (const record of records) {
    let tot = 0;
    if (!record.numbers) {
      throw {
        code: OrgbrainErrorCodes.SHARE_NUMBERS_INCONSISTANT_RECORD_WITHOUT_NUMBERS,
        message: `linje ${i} har ingen aksjenummer`,
      };
    }

    for (const number of record.numbers) {
      tot += number.to - number.from;
      numbers.push(number);
    }
    if (record.amount !== tot) {
      throw {
        code: OrgbrainErrorCodes.SHARE_NUMBERS_INCONSISTANT_RECORD_AMOUNT_MISMATCH,
        message: `linje ${i}, og at det er flere eller færre aksjer enn totalen av nummerene. Antall aksjer ${record.amount}, totalen fra nummerene frem til denne linjen er ${tot}`,
        record,
      };
    }
    i++;
  }

  numbers.sort((a, b) => {
    if (a.from > b.from) return 1;
    if (b.from > a.from) return -1;
    return 0;
  });

  let lastNumber = { to: 0 };
  i = 1;
  for (const number of numbers) {
    if (allowGaps) {
      if (lastNumber.to > number.from) {
        throw {
          code: OrgbrainErrorCodes.SHARE_NUMBERS_INCONSISTANT_OVERLAP,
          message: `${i}. Det er overlapp i nummerene: ${lastNumber}  ${number}`,
        };
      }
    } else {
      if (lastNumber.to !== number.from) {
        throw {
          code: OrgbrainErrorCodes.SHARE_NUMBERS_INCONSISTANT_GAPS,
          message: '${i}',
        };
      }
    }
    lastNumber = number;
    i++;
  }

  return lastNumber.to;
}
// this function finds the greatest share number which exists, this is used to bacause new shares will be placed after this, never before the greatest number because everything before this has been used
export function getLastSharenumber(records: ShareholderRecord[]) {
  return (
    records.reduce((acc: number, rec) => {
      if (rec.numbers) {
        rec.numbers.forEach((range) => {
          if (range.to > acc) {
            acc = range.to;
          }
        });
      }
      return acc;
    }, 0) || 0
  );
}
